import React, { useState } from "react";
import Select from "react-dropdown-select";
import DropdownList from "../Patient/partial/DropdownList";
import { CREATE } from "../../queries/rota.query";
import { useMutation } from "@apollo/react-hooks";
import LoadingSpinner from "../../partials/loading";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
import { CleanMessage } from "../../util/app";
import { sendNotification } from "../../sockette";
import { ACTION_TYPE, EVENT_TARGET } from "../../event/model";

const CreateRota = ({ staff = [], periodList = [], onCancel }) => {
    const [model, setModel] = useState({ date: new Date(), endDate: new Date() });

    const [createRota, { loading }] = useMutation(CREATE, {
        onCompleted: (d) => {
            toast.success(d.CreateRota.message);
            sendNotification(model, ACTION_TYPE.CREATE, EVENT_TARGET.ROTA);
            onCancel();
        },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });

    const [selectedPeriod, setPeriod] = useState(null);
    const [staffList, setStaffList] = useState([]);

    const staffOptions = staff.map((item) => ({
        id: item.id,
        display: `${item.surname} ${item.first_name} (${item.email})`,
    }));
    return (
        <div className="fade-in">
            <div className="card">
                <div className="card-body m-b-20">
                    <LoadingSpinner loading={loading} />
                    <form
                        action="POST"
                        onSubmit={async (e) => {
                            e.preventDefault();
                            // create rota
                            if (selectedPeriod)
                                await createRota({
                                    variables: {
                                        model: {
                                            appointee: staffList.map((i) => i.id),
                                            rota_duty_peroid: selectedPeriod.id,
                                            date: model.date,
                                            endDate: model.endDate,
                                        },
                                    },
                                });
                            else toast.warn("Rota duty is required!");
                        }}
                    >
                        <div className="row">
                            <div className="col-4 bg-primary pl-5">
                                <h5>Schedule New Rota</h5>
                            </div>
                            <div className="col-12">
                                <table className="table table-bordered">
                                    <tbody>
                                        <tr>
                                            <td style={{ width: "50%", backgroundColor: "aliceblue" }}>
                                                <strong>Period*</strong>
                                            </td>
                                            <td style={{ width: "50%" }}>
                                                <DropdownList title="" items={periodList} value="id" displayText="name" id="period_id" onSelect={(item) => setPeriod(item)} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ width: "50%", backgroundColor: "aliceblue" }}>
                                                <strong>Rota Date & Time*</strong>
                                            </td>
                                            <td style={{ width: "50%" }}>
                                                <DatePicker
                                                    selected={model.date}
                                                    onChange={(date) =>
                                                        setModel({
                                                            ...model,
                                                            date,
                                                            endDate: date,
                                                        })
                                                    }
                                                    className="form-control input-height"
                                                    timeIntervals={5}
                                                    showTimeSelect
                                                    timeCaption="Time"
                                                    dateFormat="MMM d, yyyy h:mm aa"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ width: "50%", backgroundColor: "aliceblue" }}>
                                                <strong>End of duty Time*</strong>
                                            </td>
                                            <td style={{ width: "50%" }}>
                                                <DatePicker
                                                    selected={model.endDate}
                                                    onChange={(date) => setModel({ ...model, endDate: date })}
                                                    className="form-control input-height"
                                                    timeIntervals={5}
                                                    showTimeSelect
                                                    timeCaption="Time"
                                                    dateFormat="MMM d, yyyy h:mm aa"
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-4 bg-primary pl-5">
                                <h5>Choose Staff</h5>
                            </div>
                            <div className="col-12">
                                <table className="table table-bordered">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <Select
                                                    options={staffOptions}
                                                    className="input-height"
                                                    multi={true}
                                                    valueField="id"
                                                    labelField="display"
                                                    onChange={(values) => setStaffList(values)}
                                                    searchable={true}
                                                    color="#0066f5"
                                                    searchBy="display"
                                                    addPlaceholder="+ Select Staff"
                                                    clearable={true}
                                                    separator={true}
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="form-group text-center m-t-20">
                            <button
                                type="submit"
                                disabled={staff || periodList || loading ? false : true}
                                className="mdl-button mdl-button--raised mdl-js-ripple-effect margin-right-10 m-t-20 btn-circle btn-success"
                            >
                                Submit Rota <i className="material-icons">keyboard_arrow_down</i>
                            </button>
                            <button type="button" onClick={onCancel} className="mdl-button mdl-button--raised mdl-js-ripple-effect m-t-20 btn-circle">
                                Cancel <i className="material-icons text-danger">close</i>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CreateRota;
